import {
  AccountingFilters,
  GenerateProfessionalInvoicesBody,
} from "@ac-expo/api-types";
import { useMutation } from "@tanstack/react-query";
import { handleApiCall } from "../api-error-handler";
import { privateAxios } from "../axiosInstances";

const exportPrestationsAccounting = async (filters?: AccountingFilters) => {
  const { data } = await privateAxios.get<Blob>(
    `/accounting/prestations/export`,
    {
      params: filters,
      responseType: "blob",
    }
  );
  return data;
};

export const useExportPrestationsAccounting = () => {
  return useMutation({
    mutationFn: (filters?: AccountingFilters) =>
      exportPrestationsAccounting(filters),
  });
};

const exportTicketingAccounting = async (filters?: AccountingFilters) => {
  const { data } = await privateAxios.get<Blob>(
    `/accounting/ticketing/export`,
    {
      params: filters,
      responseType: "blob",
    }
  );
  return data;
};

export const useExportTicketingAccounting = () => {
  return useMutation({
    mutationFn: (filters?: AccountingFilters) =>
      exportTicketingAccounting(filters),
  });
};

const exportPurchasesAccounting = async (filters?: AccountingFilters) => {
  const { data } = await privateAxios.get<Blob>(
    `/accounting/purchases/export`,
    {
      params: filters,
      responseType: "blob",
    }
  );
  return data;
};

export const useExportPurchasesAccounting = () => {
  return useMutation({
    mutationFn: (filters?: AccountingFilters) =>
      exportPurchasesAccounting(filters),
  });
};

const exportClientsAccounting = async () => {
  const { data } = await privateAxios.get<Blob>(`/events/accounting/export`, {
    responseType: "blob",
  });
  return data;
};

export const useExportClientsAccounting = () => {
  return useMutation({
    mutationFn: exportClientsAccounting,
  });
};

const exportInvoicesAccounting = async (filters?: AccountingFilters) => {
  const { data } = await privateAxios.get<Blob>(`/accounting/invoices/export`, {
    params: filters,
    responseType: "blob",
  });
  return data;
};

export const useExportInvoicesAccounting = () => {
  return useMutation({
    mutationFn: (filters?: AccountingFilters) =>
      exportInvoicesAccounting(filters),
  });
};

const generateProfessionalInvoices = (
  body: GenerateProfessionalInvoicesBody
) => handleApiCall(() => privateAxios.post("/invoice/generate-professional", body));

export const useGenerateProfessionalInvoices = () => {
  return useMutation({
    mutationFn: generateProfessionalInvoices,
  });
};
